import { Box, Button, Typography } from '@mui/material'

import { sectionTitle, SectionType } from '@ecm/ui/component/caseStudies/CaseStudyArticle'
import Color from '@ecm/ui/element/Color'

type ContentNavProps = {
  activeSection: SectionType
  onClick: (id: SectionType) => void
}

const ContentNav = ({ activeSection, onClick }: ContentNavProps) => (
  <Box mt="40px" position="sticky" top="100px" display={{ md: 'block', xs: 'none' }}>
    <Typography variant="overline" color={Color.saint.lightest} mb="20px">
      Contents
    </Typography>

    <Box
      component="nav"
      position="relative"
      pl="23px"
      sx={{
        '&:before': {
          backgroundColor: Color.smoke.normal,
          content: '""',
          height: '100%',
          left: 0,
          position: 'absolute',
          width: '1px',
        },
      }}
    >
      {Object.entries(sectionTitle).map(entry => {
        const [id, title] = entry as [SectionType, string] // type assertion is needed because Object.entries overwrites key type
        return (
          <Button
            variant="text"
            key={id}
            onClick={() => onClick(id)}
            sx={{
              color:
                activeSection === id
                  ? `${Color.saint.normal} !important`
                  : `${Color.saint.lightest} !important`,
              display: 'block',
              fontSize: '16px',
              fontWeight: 700,
              lineHeight: '24px',
              mb: '16px',
              textAlign: 'left',
              ...(activeSection === id
                ? {
                    '&:before': {
                      backgroundColor: Color.saint.normal,
                      content: '""',
                      height: '100%',
                      left: '-23px',
                      position: 'absolute',
                      width: '4px',
                    },
                  }
                : {}),
            }}
          >
            {title}
          </Button>
        )
      })}
    </Box>
  </Box>
)

export default ContentNav
